import React, { useState } from "react";
import { useTabletMediaQuery, useMobileMediaQuery } from '../utils';
import '../css/customButtonSelectOption.css';


const CustomButtonSelectOption = (props) => {
    const {
        text = '',
        onPress = () => { },
        isActive = false,
        enabled = false,
    } = props;

    const isTablet = useTabletMediaQuery();
    const isMobile = useMobileMediaQuery();

    const buttonClass = isTablet
        ? ( isActive ? 'btnCustomButtonSelectOption active' : 'btnCustomButtonSelectOption')
        : ( isMobile ? ( isActive ? 'btnCustomButtonSelectOption active' : 'btnCustomButtonSelectOption') 
        : ( isActive ? 'btnCustomButtonSelectOptionMobile active' : 'btnCustomButtonSelectOptionMobile' ) );

    return (
        <>
        <button
            className={buttonClass}
            type='button'
            onClick={onPress}
            disabled={enabled}
        >
            {text}
        </button>
        </>
    );
};

export default CustomButtonSelectOption;